export function getCustomerMatches(context, { customerId, searchResultId }) {
  let searchResult = context.stores.universalSearchResults.findBy({ id: searchResultId });
  return searchResult && searchResult.hits.filter(c => c.id !== customerId);
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_match/lib/get_customer_matches.js